import { render, staticRenderFns } from "./groups-edit.vue?vue&type=template&id=f8c85f1e&"
import script from "./groups-edit.vue?vue&type=script&lang=js&"
export * from "./groups-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports